import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';
import { otpValidation } from '../models/otpValidation.model';
import { getLocaleDateFormat } from '@angular/common';
//import { AnyMxRecord, AnyTxtRecord } from 'dns';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};
const httpOptionsForAutoSuggest = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json', 'ignoreLoadingBar': '' })
};
@Injectable({ providedIn: 'root' })
export class ProductService {
  
  private httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };
  constructor(private http: HttpClient) { }

  getCMSContent(U: string, M: string): Observable<any> {
    const cmscontentURLobj = { url: U, method: M };
    return this.http.post(
      `${environment.ECARE_URL}/getEshopHTML.service`,
      cmscontentURLobj,
      httpOptions
    );
  }

  getLibs(U: string, M: string): Observable<any> {
    const cmscontentURLobj = { url: U, method: M };
    return this.http.post(
      `${environment.ECARE_URL}/getLibs.service`,
      cmscontentURLobj,
      httpOptions
    );
  }

  getProductsByCategory(
    L: string,
    iADF: number = 1,
    C: string, //categoryId
    NS: string, //navigationState
    N: string = '0' //index number
  ): Observable<any> {
    const payload = { categoryId: C, navigationState: NS, No: N };
    const currentAccount = (localStorage.getItem('currentAccount')) ? JSON.parse(localStorage.getItem('currentAccount')) : null;
    if (currentAccount) {
      return this.http.post(
        `${environment.ECARE_URL
        }/getShopForMoreHybrid.service?locale=${L}
        `,
        payload,
        httpOptions
      );
    }
    else {
      return this.http.post(
        `${environment.BASE_URL
        }/getProductsByCategory?locale=${L}&isApplyDefaultFilters=${iADF == 1 ? true : false
        }`,
        payload,
        httpOptions
      );
    }
  }

  getMobileEligibility(accountNo: number): Observable<any> {
    const payload = { accountNumber: accountNo };
    return this.http.post(
      `${environment.ECARE_URL}/getAccountType.service`,
      payload,
      httpOptions
    );
  }

  accountTypeValidation(accountNo: number): Observable<any> {
    const payload = {
      accountNo: accountNo,
      accountType: "postpaid",
      isAccountId: false
    };
    return this.http.post(
      `${environment.ECARE_URL}/accountTypeValidation.service`,
      payload,
      httpOptions
    );
  }

  generateOTP(accountNo: number): Observable<any> {
    const payload = { "accountNo": accountNo, "notificationType": "SMS", "notificationValue": accountNo,"category":"plantATree" };
    return this.http.post(
      `${environment.BASE_URL}/generateOtpByAccountNumber`,
      payload,
      httpOptions
    );
  }

  validateOTP(otpValidation: otpValidation): Observable<any> {
    return this.http.post(
      `${environment.BASE_URL}/validateOtpAccountNumber`,
      otpValidation,
      httpOptions
    );
  }

  getAccountType(accountNumber: string): Observable<any> {
    const payload = { "accountNumber": accountNumber };
    return this.http.post(
      `${environment.ECARE_URL}/getAccountType.service`,
      payload,
      httpOptions
    );
  }

  getOnlineRechargeList() : any {
    return this.http 
      .get(environment.BASE_URL + `/getRechargeList`,this.httpOptions);
  }

  geteInitiativeCampaignsData() : any {
    return this.http 
      .get(environment.BASE_URL + `/getEInitiativeCampaignsData.service`,this.httpOptions);
  }
  
  saveeInitiativeCampaignsData(payload: any): Observable<any> {
    return this.http.post(
      `${environment.BASE_URL}/saveEInitiativeCampaignsData.service`,
      payload,
      httpOptions
    );
  }
}
